import { TFunction } from "i18next";
import { z } from "zod";

export const modulerRiskSchema = (t: TFunction) => {
  return z.object({
    reason: z.string().min(1, { message: t("global.form.error.mandatoryField") }),
  });
};

export type ModulerRiskFormValues = z.infer<ReturnType<typeof modulerRiskSchema>>;

export const defaultModulerRiskValues = (forcedReason: {
  code: string;
  name: string;
}): ModulerRiskFormValues => {
  const reason = forcedReason?.code;

  return {
    reason: reason ?? "",
  };
};
